export default __webpack_public_path__ + "static/media/tostador.1c389378.png";